import { useEffect } from "react";
import { toast } from "sonner";
import { ArrowRight, Download, X } from "lucide-react";
import { BACKEND_URL } from "./backendUrl";

export const ImageModal = ({ image, onClose, onDecline }) => {
  const label = image.label || (image.isOriginal || image.index === "original" ? "Image originale" : `Variation #${image.index}`);
  const filename = image.filename || `variation_${image.index}.png`;
  const src = image.url?.startsWith("blob:") || image.url?.startsWith("http") ? image.url : `${BACKEND_URL}${image.url}`;

  useEffect(() => {
    const handler = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [onClose]);

  const download = async () => {
    try {
      const downloadUrl = image.url?.startsWith("blob:") || image.url?.startsWith("http") ? image.url : `${BACKEND_URL}${image.url}`;
      const res = await fetch(downloadUrl, { credentials: "include" });
      const blob = await res.blob();
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = filename;
      a.click();
      URL.revokeObjectURL(a.href);
    } catch {
      toast.error("Échec du téléchargement");
    }
  };

  return (
    <div
      className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-center justify-center p-6 animate-in fade-in duration-200"
      onClick={onClose}
      data-testid="image-modal"
    >
      <button
        onClick={onClose}
        data-testid="close-image-modal-button"
        className="absolute top-4 right-4 w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center text-white transition-colors"
      >
        <X className="w-5 h-5" />
      </button>
      <div
        className="relative max-w-[90vw] max-h-[90vh] flex flex-col items-center gap-6"
        onClick={(e) => e.stopPropagation()}
      >
        <span className="text-white/80 text-xs font-mono uppercase tracking-[0.2em]">
          {label}
        </span>
        <img
          src={src}
          alt={label}
          className="max-w-full max-h-[70vh] object-contain rounded-xl shadow-2xl"
        />
        <button
          onClick={download}
          data-testid="modal-download-button"
          className="bg-white text-slate-900 px-6 py-3 rounded-full flex items-center gap-2 font-bold text-sm hover:bg-slate-100 hover:scale-105 transition-all shadow-2xl"
        >
          <Download className="w-4 h-4" /> Télécharger
        </button>
        {onDecline && (
          <button
            onClick={onDecline}
            data-testid="modal-decline-button"
            className="bg-[#f58207] text-white px-6 py-3 rounded-full flex items-center gap-2 font-bold text-sm hover:bg-[#c86b05] hover:scale-105 transition-all shadow-2xl"
          >
            <ArrowRight className="w-4 h-4" /> Décliner cette image
          </button>
        )}
      </div>
    </div>
  );
};
